import { render, staticRenderFns } from "./MisPedidos.vue?vue&type=template&id=126ffbe0&scoped=true&"
import script from "./MisPedidos.vue?vue&type=script&lang=js&"
export * from "./MisPedidos.vue?vue&type=script&lang=js&"
import style0 from "./MisPedidos.vue?vue&type=style&index=0&id=126ffbe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126ffbe0",
  null
  
)

export default component.exports